import React from 'react';
import { Grid, styled, Icon } from '@mui/material';
import { Colors, Text } from 'library';
import { Check } from '@mui/icons-material';

export default function SuccessMessage({ visible }: { visible: boolean }) {
    if (!visible) return null;
    return (
        <Grid container xs={12} justifyContent="flex-start" height="fit-content" marginBottom={4}>
            <SuccessContainer>
                <Icon
                    component={Check}
                    style={{
                        color: Colors.white,
                        backgroundColor: Colors.turquoise,
                        borderRadius: 100,
                        padding: 5,
                        marginRight: 10,
                    }}
                />
                <Text>Good news! We found some great teachers near you!</Text>
            </SuccessContainer>
        </Grid>
    );
}

const SuccessContainer = styled('div')({
    backgroundColor: Colors.lightTurq,
    border: `1px solid ${Colors.turquoise}`,
    borderRadius: 16,
    display: 'flex',
    height: 'fit-content',
    padding: 15,
    width: 'fit-content',
});
